// Simple controlled Tabs
export default function Tabs({
  value, // string: the active tab key
  onChange, // (key) => void
  items = [], // [{ key, label, disabled?, dropdown?: [{ key, label }] }]
  className = "",
}) {
  return (
    <div
      className={`flex gap-3 mb-4 overflow-x-auto whitespace-nowrap flex-nowrap scrollbar-thin -mx-1 px-1 ${className}`}
      role="tablist"
    >
      {items.map((t) => {
        const hasDropdown = t.dropdown?.length > 0;
        const active =
          value === t.key || (hasDropdown && t.dropdown.some((item) => item.key === value));
        return (
          <div key={t.key} className="relative group">
            <button
              type="button"
              disabled={t.disabled}
              role="tab"
              aria-selected={active}
              onClick={() => {
                if (t.disabled) return;
                if (!hasDropdown) onChange?.(t.key);
              }}
              className={`shrink-0 px-5 py-2 rounded-full font-bold transition-colors ${
                active
                  ? "bg-palette-indigo-badge text-white"
                  : "bg-palette-indigo-soft text-palette-indigo-heading hover:bg-palette-indigo-muted"
              } ${t.disabled ? " opacity-50 cursor-not-allowed" : ""}`}
            >
              {t.label}
              {hasDropdown && <span className="ml-1.5 text-[10px]">▾</span>}
            </button>

            {hasDropdown && (
              <div className="absolute left-0 top-full z-50 hidden w-56 pt-2 group-hover:block">
                <div className="flex flex-col overflow-hidden rounded-xl border border-palette-gray-divider bg-white py-1 shadow-lg">
                  {t.dropdown.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      onClick={() => onChange?.(item.key)}
                      className={`block w-full text-left px-4 py-3 text-sm font-medium transition-colors ${
                        value === item.key
                          ? "bg-palette-blue-soft text-palette-blue-heading"
                          : "text-palette-slate-heading hover:bg-palette-gray-soft"
                      }`}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
